<template>
	<div :class="['c-export', { active: active === true }]">
		<div class="c-export__section">
			<h5>12 blocks for export</h5>
			<span class="btn-close"></span>
		</div>
		<div class="c-export__section">
			<EmailSelector></EmailSelector>
		</div>
		<div class="c-export__section">
			<div class="c-export__list">
				<a href="#" class="c-export__btn"> Send to Zapier </a>
				<a href="#" class="c-export__btn"> Copy as HTML </a>
			</div>
		</div>
	</div>
</template>

<script>
import EmailSelector from '@/components/ui/email-selector';
export default {
	components: {
		EmailSelector,
	},

	computed: {
		selection: function () {
			return this.$store.getters['dashboard/selection'] || [];
		},
		active: function () {
			if (this.selection.length > 0) {
				return true;
			} else {
				return false;
			}
		},
	},
};
</script>

<style lang="scss">
.c-export {
	position: fixed;
	z-index: var(--z-2);
	bottom: 10px;
	left: calc(50% - 200px);
	width: 400px;
	height: auto;
	background-color: var(--p5);
	border-radius: var(--border-radius-lg);
	box-shadow: 0 1.7px 2.5px rgba(0, 0, 0, 0.101),
		0 5.8px 8.5px rgba(0, 0, 0, 0.149), 0 26px 38px rgba(0, 0, 0, 0.25);
	transform: translateY(100%);
	transition: all var(--transition-time-lg)
		cubic-bezier(0.245, 0.83, 0.79, 1.04);

	&.active {
		transform: translateY(0);
	}

	&__section {
		position: relative;
		padding: var(--margin) var(--margin-lg);

		.btn-close {
			position: absolute;
		}

		> h5 {
			padding: var(--margin-lg) 0;
			margin-bottom: 0;
		}

		&:not(:last-child) {
			border-bottom: var(--g2) solid 1px;
		}
	}

	&__list {
		padding: var(--margin) 0;
	}

	&__btn {
		padding: var(--margin-lg) var(--margin-lg);
		display: block;
		font-size: var(--font-size-sm);
		background-size: var(--font-size-sm);
		background-color: var(--g3);
		color: #fff;

		&:not(:last-child) {
			border-bottom: var(--g2) solid 1px;
		}

		&:first-child {
			border-top-left-radius: 5px;
			border-top-right-radius: 5px;
		}

		&:last-child {
			border-bottom-left-radius: 5px;
			border-bottom-right-radius: 5px;
		}
	}
}
</style>